package cc.easyandroid.easycompose.core.backhandler

internal fun Iterable<BackCallback>.findMostImportant(): BackCallback? =
    sortedBy(BackCallback::priority).lastOrNull(BackCallback::isEnabled)
